export const PRIMARY_DIALOG_BUTTON_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogPrimaryButtonElement';
export const SECONDARY_DIALOG_BUTTON_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogSecondaryButtonElement';
export const IMAGE_DIALOG_BUTTON_ELEMENT = 'Web.TemplatesInterface.v1_0.Touch.DialogTemplateInterface.DialogImageButtonElement';
